export default {
  interviewQuestions: [],
  interviewQuestion: undefined,
};
